import { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { logError } from 'utils/logger';
import { getTaskList } from '../../service';
import { getWorkProgressSteps } from '../utils';

export default function useWorkProgressSection({ projectId, totalDrawings }) {
  const [taskList, setTaskList] = useState(null);
  const [loading, setLoading] = useState(false);

  const workProgressSteps = useMemo(
    () => getWorkProgressSteps(taskList, totalDrawings),
    [taskList, totalDrawings],
  );

  const fetchTaskList = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getTaskList(projectId);
      setTaskList(data.tasks || []);
    } catch (error) {
      toast.error(
        logError({
          message: 'Failed to fetch task list',
          error: error,
          code: 'WORK_PROGRESS_SECTION_FETCH_TASK_LIST_FAILED',
        }),
      );
      setTaskList([]);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    if (projectId) {
      fetchTaskList();
    }
  }, [fetchTaskList, projectId]);

  return {
    taskList,
    loading,
    refresh: fetchTaskList,
    workProgressSteps,
  };
}
